import React from 'react';
import EntityTable from './table/EntityTable';
import LockToggle from './LockToggle';
import moment from 'moment';
import {withNamespaces} from 'react-i18next';

const _tableConfig = (toggleDeviceBlocking, t) => ({
  maxRows: 5,
  cols: [
    {
      header: t('logList.time'),
      valueKey: 'createdAtStr',
      method: (createdAtStr) => moment(createdAtStr).format('LLL'),
      width: '28%',
    },
    {
      header: t('logList.type'),
      valueKey: 'type',
      method: (type) => type,
      width: '28%',
    },
    {
      header: t('logList.device'),
      valueKey: 'device',
      method: ({name}) => name,
      width: '28%',
    },
    {
      header: <div style={{textAlign: 'center'}}>{t('logList.locked')}</div>,
      valueKey: 'device',
      method: (device) => <LockToggle locked={!device.active} toggleLock={() => toggleDeviceBlocking(device)} />,
      width: '16%',
    },
  ],
  filterString: ({device: {name}, type, createdAtStr}) => moment(createdAtStr).format('LLL') + name + type,
});

const LogList = ({logs, toggleDeviceBlocking, t}) => {
  const tableConfig = _tableConfig(toggleDeviceBlocking, t);
  return <EntityTable tableConfig={tableConfig} data={logs} msg={t('logList.noLogs')} />;
};
export default withNamespaces()(LogList);



// WEBPACK FOOTER //
// ./src/components/LogList.js